import React from "react";
import {Link, useNavigate} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {resetLoginStatus, logout} from "../../store/reducers/AuthSlice";

interface RibbonProps {
}

export const Ribbon: React.FC<RibbonProps> = () => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const infoState = useAppSelector(state => state.info);

    return (
        <>
            <div id="ribbon">
                <div id="bar">
                    <p id="user">
                        <span>
                            Järgmine päring: <strong>{infoState?.nextUser?.firstname}  </strong>
                        </span>
                        {infoState?.me?.firstname}
                        {(infoState?.me?.logistician === 1 || infoState?.me?.is_checker === 1) &&
                        <>
                            {infoState?.me?.offline === 1 && <Link to={'/user-status'}><img
                              src={process.env.PUBLIC_URL + '/gfx/ico_red_bullet.png'}/></Link>}
                            {infoState?.me?.offline != 1 && <Link to={'/user-status'}><img
                              src={process.env.PUBLIC_URL + '/gfx/ico_green_bullet.png'}/></Link>}
                        </>
                        }

                    </p>
                    <p id="logout">
                        <Link to={'/login'} onClick={() => {
                            dispatch(logout());
                        }}>Välju</Link>
                    </p>
                </div>
            </div>
        </>
    );

}